import React, { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

const PwaLoginPage = lazy(() => import('../pwa/pages/PwaLoginPage').then(m => ({ default: m.PwaLoginPage })));
const PwaRegisterPage = lazy(() => import('../pwa/pages/PwaRegisterPage').then(m => ({ default: m.PwaRegisterPage })));
const PwaLayout = lazy(() => import('../pwa/components/PwaLayout').then(m => ({ default: m.PwaLayout })));
const PwaHomePage = lazy(() => import('../pwa/pages/PwaHomePage').then(m => ({ default: m.PwaHomePage })));
const PwaCardPage = lazy(() => import('../pwa/pages/PwaCardPage').then(m => ({ default: m.PwaCardPage })));
const PwaPaymentsPage = lazy(() => import('../pwa/pages/PwaPaymentsPage').then(m => ({ default: m.PwaPaymentsPage })));
const PwaMapPage = lazy(() => import('../pwa/pages/PwaMapPage').then(m => ({ default: m.PwaMapPage })));
const PwaOmbudsmanPage = lazy(() =>
  import('../pwa/pages/PwaOmbudsmanPage').then(m => ({ default: m.PwaOmbudsmanPage }))
);
const PwaSettingsPage = lazy(() => import('../pwa/pages/PwaSettingsPage').then(m => ({ default: m.PwaSettingsPage })));
const PwaAgendaPage = lazy(() => import('../pwa/pages/PwaAgendaPage').then(m => ({ default: m.PwaAgendaPage })));
const PwaTrainingsPage = lazy(() =>
  import('../pwa/pages/PwaTrainingsPage').then(m => ({ default: m.PwaTrainingsPage }))
);

export function PwaRoutes() {
  return (
    <Routes>
      <Route path="login" element={<PwaLoginPage />} />
      <Route path="register" element={<PwaRegisterPage />} />
      <Route path="*" element={<PwaLayout />}>
        <Route index element={<Navigate to="home" replace />} />
        <Route path="home" element={<PwaHomePage />} />
        <Route path="card" element={<PwaCardPage />} />
        <Route path="payments" element={<PwaPaymentsPage />} />
        <Route path="map" element={<PwaMapPage />} />
        <Route path="ombudsman" element={<PwaOmbudsmanPage />} />
        <Route path="agenda" element={<PwaAgendaPage />} />
        <Route path="trainings" element={<PwaTrainingsPage />} />
        <Route path="settings" element={<PwaSettingsPage />} />
      </Route>
    </Routes>
  );
}
